/* eslint-disable @typescript-eslint/no-explicit-any */
import { RouteComponentProps } from 'react-router-dom';
import { oc } from 'ts-optchain';

import { IWithContextProps, withContext } from '@tock/coretypes';
import { Typography } from 'omakase';
import BaseComponent from '@tock/shared/components/BaseComponent';
import BookingHistory from 'components/account/BookingHistory';
import LoadingComponent from '@tock/shared/components/LoadingComponent';
import PartnerBookingsDropdown from 'components/account/PartnerBookingsDropdown';
import connect, { DefaultConnectProps, StoreType } from '@tock/shared/utils/connect';

interface ConnectProps extends DefaultConnectProps {
  patron: StoreType['patron'];
}

type AllProps = RouteComponentProps<any> & ConnectProps & IWithContextProps;
class PartnerBookingsRoute extends BaseComponent<AllProps> {
  componentDidMount() {
    this.props.actions.navigation.set({
      title: 'Concierge Reservations',
    });
    this.handleLoadData(this.props);
  }

  handleLoadData(props: AllProps) {
    const partnerId = props.app.activeAuth.partnerId;
    if (partnerId) {
      this.props.actions.patron.fetchPartnerPurchaseHistory(partnerId);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: AllProps) {
    if (this.props.app.activeAuth.partnerId !== nextProps.app.activeAuth.partnerId) {
      this.handleLoadData(nextProps);
    }
  }

  handleChangeBookings(option: SelectOption) {
    this.props.history.push(`/profile/${option.value}`);
  }

  render() {
    if (!this.props.app.activePartnerRole) {
      return null;
    }
    const {
      app: {
        settings,
        activePartnerRole: { partner },
      },
      patron: { partnerPurchaseHistory, isPartnerReservationsInitialized },
    } = this.props;
    const requestInProgress = this.props.app.requestInProgress || !isPartnerReservationsInitialized;
    return (
      <div className="MainContent">
        <div className="SectionWrapper">
          <div className="SectionContent">
            <div className="Reservations-switcherContainer">
              <div className="Reservations-dropdownContainer">
                <PartnerBookingsDropdown
                  partnerName={oc(partner).name() || ''}
                  onChangeBookings={this.handleChangeBookings}
                />
              </div>
            </div>
            <h2 className="Reservations-subheading">
              <Typography variant="heading02">Upcoming Concierge Bookings</Typography>
            </h2>
            <LoadingComponent
              containerClassName="Reservations-container"
              showOverlay={!!partnerPurchaseHistory}
              isLoading={requestInProgress}
              isBallPulse={true}
            >
              {partnerPurchaseHistory && (
                <BookingHistory
                  emptyStateText="No upcoming reservations."
                  history={partnerPurchaseHistory}
                  showBookingActions={false}
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  userLocale={settings!.USER_LOCALE}
                />
              )}
            </LoadingComponent>
          </div>
        </div>
      </div>
    );
  }
}

export default connect<RouteComponentProps<any>, ConnectProps>(
  withContext(PartnerBookingsRoute),
  (state: StoreType) => {
    return {
      app: state.app,
      patron: state.patron,
    };
  }
);
